import * as React from "react"

const SvgMagicWand = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m5.989 6.546-.707 1.626a.44.44 0 0 1-.806 0l-.707-1.626-1.626-.707a.44.44 0 0 1 0-.806l1.626-.707.707-1.626a.44.44 0 0 1 .806 0l.707 1.626 1.626.707a.44.44 0 0 1 0 .806zm9.726 1.67.589-1.355 1.355-.59a.366.366 0 0 0 0-.671l-1.355-.59-.59-1.354a.366.366 0 0 0-.671 0l-.589 1.355-1.355.589a.366.366 0 0 0 0 .672l1.355.589.589 1.355a.366.366 0 0 0 .672 0m-11.096 6.96-.471 1.084a.293.293 0 0 1-.538 0l-.471-1.084-1.084-.472a.293.293 0 0 1 0-.537l1.084-.471.471-1.084a.293.293 0 0 1 .538 0l.47 1.084 1.085.471a.293.293 0 0 1 0 .537z" />
    <path
      fillRule="evenodd"
      d="M8.88 8.022a2 2 0 0 1 2.828 0l9.584 9.585a2 2 0 0 1 0 2.828l-1.414 1.414a2 2 0 0 1-2.828 0l-9.585-9.584a2 2 0 0 1 0-2.828zm1.414 1.415 1.414 1.414-1.414 1.414-1.414-1.414zm8.17 10.998-6.756-6.756 1.414-1.414 6.756 6.756z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgMagicWand
